/**
 * Google Consent Mode v2, driven by Shopify's cookie banner.
 *
 * snippets/google-tag.liquid sets region-scoped DEFAULTS before Google's tag
 * loads. This file replaces them with the visitor's real answer, read from
 * Shopify's Customer Privacy API, and keeps Google in step if they change it.
 *
 * SHOPIFY IS THE AUTHORITY. Whether a visitor must be asked is configured once,
 * in Shopify admin (Customer privacy, Cookie banner, Regions). This file never
 * second-guesses that: where Shopify says no consent is required, its API
 * reports marketing and analytics as allowed, and Google is told so. Keeping a
 * second region list here would let the two drift apart, and a visitor could be
 * shown a banner whose answer Google never hears.
 *
 * Mapping. Shopify's Marketing category controls Google's three advertising
 * signals; its Analytics category controls analytics_storage. Personalization
 * has no Google equivalent.
 *
 * Global Privacy Control. A browser that sends it has asked not to have its
 * data sold or shared, which is the US state-law opt-out. Honoured everywhere
 * and always: ad personalisation off, restricted data processing on. It never
 * blocks measurement.
 *
 * FAIL SAFE: if the API cannot be loaded, nothing is updated and the defaults
 * stand, which means denied in every region that requires consent.
 */
(function () {
  'use strict';

  if (window.__duavaaGoogleConsentLoaded) return; // double-include guard
  window.__duavaaGoogleConsentLoaded = true;

  if (typeof window.gtag !== 'function') return;

  var gpc = navigator.globalPrivacyControl === true;
  var applied = null;

  function apply(marketing, analytics) {
    var state = {
      ad_storage: marketing ? 'granted' : 'denied',
      ad_user_data: marketing ? 'granted' : 'denied',
      ad_personalization: marketing && !gpc ? 'granted' : 'denied',
      analytics_storage: analytics ? 'granted' : 'denied'
    };
    var key = JSON.stringify(state);
    if (key === applied) return;
    applied = key;
    window.gtag('consent', 'update', state);
  }

  function fromApi() {
    try {
      var cp = window.Shopify && window.Shopify.customerPrivacy;
      if (!cp || typeof cp.marketingAllowed !== 'function') return false;
      apply(!!cp.marketingAllowed(), !!cp.analyticsProcessingAllowed());
      return true;
    } catch (e) {
      return false;
    }
  }

  if (gpc) {
    window.gtag('set', 'restricted_data_processing', true);
    window.gtag('consent', 'update', { ad_personalization: 'denied' });
  }

  // The banner's answer, and any later change from the preferences panel.
  document.addEventListener('visitorConsentCollected', function (event) {
    var d = (event && event.detail) || {};
    apply(!!d.marketingAllowed, !!d.analyticsAllowed);
  });

  // The API is only on the page where Shopify's banner runs, so ask for it.
  function requestApi() {
    if (fromApi()) return;
    try {
      if (window.Shopify && typeof window.Shopify.loadFeatures === 'function') {
        window.Shopify.loadFeatures(
          [{ name: 'consent-tracking-api', version: '0.1' }],
          function (error) {
            if (error) return; // defaults stand
            fromApi();
          }
        );
      }
    } catch (e) {
      // defaults stand
    }
  }

  // This file is loaded from the very top of head, so it can run before
  // Shopify's own head scripts have defined window.Shopify. Then wait for the
  // document to be parsed instead of giving up, or a returning visitor who
  // had already accepted would stay at the denied default.
  if (window.Shopify) {
    requestApi();
  } else if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', requestApi, { once: true });
  } else {
    requestApi();
  }
})();
